import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

interface ProviderStatus {
  grok: boolean;
  openai: boolean;
  xai: boolean;
}

export function useAvailableProviders() {
  const { apiKeys } = useAuth();
  const [providers, setProviders] = useState<ProviderStatus>({ grok: false, openai: false, xai: false });

  useEffect(() => {
    if (apiKeys) {
      setProviders({
        grok: !!apiKeys.grok,
        openai: !!apiKeys.openai,
        xai: !!(apiKeys.xai || apiKeys.grok)
      });
    } else {
      setProviders({ grok: false, openai: false, xai: false });
    }
  }, [apiKeys]);

  const availableProviders = Object.entries(providers)
    .filter(([_, isAvailable]) => isAvailable)
    .map(([provider]) => provider as keyof ProviderStatus);

  const hasMultipleProviders = availableProviders.length > 1;
  const defaultProvider = availableProviders.length > 0 ? availableProviders[0] : 'grok';

  return {
    providers,
    availableProviders,
    hasMultipleProviders,
    defaultProvider,
    hasAnyProvider: availableProviders.length > 0
  };
}